import { GRAVUN_BRAND } from "@/branding";
import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Application entry point.
 *
 * Branding comes exclusively from the central brand configuration in
 * src/branding, never hard-code the product name or logo paths elsewhere.
 *
 * Domain configuration (deal stages, categories, note statuses, task types,
 * company sectors, ...) can also be passed to <CRM> here; Gravun installs
 * industry-specific configurations through workspace templates instead of
 * hard-coding a vertical at the application level.
 */
const App = () => (
  <CRM
    title={GRAVUN_BRAND.name}
    lightModeLogo={GRAVUN_BRAND.lightModeLogo}
    darkModeLogo={GRAVUN_BRAND.darkModeLogo}
  />
);

export default App;
